module.exports = __webpack_public_path__ + "static/media/logo.f26bf69f.png";